import React from 'react';
import { Section } from './Section';
import { CTAButton } from './CTAButton';
type Module = {
  number: string;
  title: string;
  summary: string;
};
const MODULES: Module[] = [{
  number: '01',
  title: 'Configuraciones esenciales',
  summary: 'Qué activar y qué desactivar, pantalla de inicio, Face ID y bloqueo.'
}, {
  number: '02',
  title: 'Batería y rendimiento',
  summary: 'Por qué se drena rápido y cómo hacer que dure muchas más horas.'
}, {
  number: '03',
  title: 'Funciones ocultas y trucos',
  summary: 'Gestos, atajos, escanear documentos y copiar texto desde fotos.'
}, {
  number: '04',
  title: 'Herramientas Apple',
  summary: 'iCloud, AirDrop, Siri, Atajos, Notas, Recordatorios y Fotos.'
}, {
  number: '05',
  title: 'Cámara, fotos y video',
  summary: 'Modo retrato y noche, luz, composición y edición desde el iPhone.'
}, {
  number: '06',
  title: 'Privacidad y seguridad',
  summary: 'Permisos de apps, contraseñas, ubicación y datos personales.'
}];
export function Curriculum() {
  return <Section className="bg-ink-900" data-id="element-112" data-mp="1jg6ktdtdepms">
      <p className="mb-3 text-xs font-semibold uppercase tracking-[0.22em] text-accent-soft" data-id="element-113" data-mp="1jh7txcqtt21v">
        El contenido
      </p>
      <h2 className="text-3xl font-extrabold leading-[1.15] tracking-tight text-white sm:text-4xl" data-id="element-114" data-mp="1x9ebn39mnh3f">
        Qué encontrás dentro de Diccionario Apple
      </h2>

      <ul className="mt-8 grid gap-2.5 md:grid-cols-2" data-id="element-115" data-mp="274g2c3jjwr84">
        {MODULES.map(module => <li key={module.number} className="flex gap-4 rounded-2xl border border-white/8 bg-ink-950 px-5 py-4" data-id="element-116" data-mp="225cukbc6s6wg">
            <span className="text-sm font-extrabold text-accent" data-id="element-117" data-mp="2g3tckyfi1jtw">
              {module.number}
            </span>
            <div data-id="element-118" data-mp="ls6acqua2h3h">
              <p className="text-sm font-bold text-white sm:text-base" data-id="element-119" data-mp="lrmpp2d8telr">
                {module.title}
              </p>
              <p className="mt-1 text-xs leading-relaxed text-white/55 sm:text-sm" data-id="element-120" data-mp="gu4mlslwptlo">
                {module.summary}
              </p>
            </div>
          </li>)}
      </ul>

      <div className="mt-8" data-id="element-121" data-mp="2ltmah4myje02">
        <CTAButton className="items-center" note="Acceso inmediato vía mail." data-id="element-122" data-mp="2luxl9oetlm0o" />
      </div>
    </Section>;
}